/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'calendar': {
    viewBox: '0 0 16 16',
    data: '<path d="M13,2V0h-1v2H4V0H3v2H0v14h16V2H13z M15,15H1V8h14V15z M15,7H1V3h2v2h1V3h8v2h1V3h2V7z"/>'
  }
})
